'use strict';

import Vue from 'vue'
import Router from 'vue-router'

import SinistreHistory from '../components/auth/SinistreHistory'
import devis_list_sunu from '../components/sunu_devis_liste.vue' // ne pas supprimer cette importation

Vue.use(Router);

export default new Router({
  mode: 'history', // supprime le hashtags # dans le url
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/kyc/thank',
      name: 'upload_kyc_thank',
      component: () => import('./../components/auth/upload_success_kyc.vue')
      // meta: {
      //     requiresAuth: true
      // }
    },
    {
      path: '/pro',
      name: 'assuraf_pro_online',
      component: () => import('./../components/assuraf_pro/assuraf_pro_online.vue')
      // meta: {
      //     requiresAuth: true
      // }
    },
    {
      path: '/devis/rcscolaire',
      name: 'rc_scolaire',
      component: () => import('./../components/RcScolaire/rcscolaire.vue')
      // meta: {
      //     requiresAuth: true
      // }
    },
    {
      path: '/lead/:identifiant?',
      name: 'lead',
      props: true,
      component: () => import('./../components/Leads/LeadPage.vue')
    },
    {
      path: '/rcscolaire',
      name: 'rc_scolaire',
      component: () => import('./../components/RcScolaire/rcscolaire_start.vue')
      // meta: {
      //     requiresAuth: true
      // }
    },
    {
      path: '/kyc/',
      name: 'upload_idcard',
      component: () => import('./../components/auth/upload_idcard.vue')
      // meta: {
      //     requiresAuth: true
      // }
    },
    {
      path: '/auth/magiclink',
      name: 'magiclink_login',
      component: () => import('./../components/auth/magiclinkAuth.vue')
      //component: magiclinkLogin,
    },
    {
      path: '/activation',
      name: 'activation',
      component: () => import('./../components/ActivationPage.vue')
    },
    {
      path: '/set-password/*',
      name: 'set_password',
      //component: SetPassword,
      component: () => import('./../components/auth/SetPassword.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reset-password',
      name: 'reset_password',
      component: () => import('./../components/auth/ResetPassword.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/auto/sunu/propositions',
      name: 'auto_sunu_propositions',
      component: devis_list_sunu
    },
    {
      path: '/auto/sunu',
      name: 'auto_sunu',
      //component: parcours_auto_sunu,
      component: () => import('./../components/parcours_dedie_sunu/index.auto.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/n/:id',
      name: 'renew',
      //component: AutoRenew,
      component: () => import('./../components/DevisAuto/auto.renew.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/n/:id/modifier',
      name: 'renew-modifier',
      component: () => import('./../components/DevisAuto/auto.renew.modifier.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/p/:id',
      name: 'parrain',
      //component: ParrainageRegister,
      component: () => import('./../components/auth/parrainage.register.vue'),
      meta: { requiresAuth: false }
    },

    {
      path: '/devis/reference/*',
      name: 'devis_reference',
      //component: devis_reference,
      component: () => import('./../components/devis_reference.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/orangemoney/success/*',
      name: 'orange_money_qr_success',
      //component: QrCodeSuccess,
      component: () => import('./../components/qrcodeSuccess.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/app',
      name: 'app_download',
      component: () => import('./../views/AppDownloadPage.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/new_home',
      name: 'new_home',
      component: () => import('./../components/NewHome.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'HHomeome',
      component: () => import('./../components/Home.vue'), // Lazy load
      //component : Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/contrat/ok',
      name: 'contrat_ok',
      //component: Contrat,
      component: () => import('./../components/Contrat.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/apropos',
      name: 'apropos',
      //component: Apropos,
      component: () => import('./../components/Apropos.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      //component: Dashboard,
      component: () => import('./../components/auth/dashboard.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/sinistre',
      name: 'sinistre',
      //component: newSinistre,
      component: () => import('./../components/Blogs/newSinistre.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/sinistre/success',
      name: 'sinistreSuccess',
      //component: sinistreSuccess,
      component: () => import('./../components/Blogs/SinistreSuccess.vue'),
      meta: { requiresAuth: true }
    },
    /*=================== PORTEFEUILLE ========================*/
    {
      path: '/portefeuille',
      name: 'portefeuille',
      component: () => import('./../components/auth/Portefeuille.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/portefeuille/vehicles',
      name: 'portefeuille-vehicles',
      component: () => import('./../components/auth/portefeuille/PortefeuilleVehicles.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/portefeuille/housings',
      name: 'portefeuille-housings',
      component: () => import('./../components/auth/portefeuille/PortefeuilleHousings.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/portefeuille/beneficiaries',
      name: 'portefeuille-beneficiaries',
      component: () => import('./../components/auth/portefeuille/PortefeuilleBeneficiaries.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/portefeuille/documents',
      name: 'portefeuille-documents',
      component: () => import('./../components/auth/portefeuille/PortefeuilleDocuments.vue'),
      meta: { requiresAuth: true }
    },
    /*=================== ASSURANCES ========================*/
    {
      path: '/assurance',
      name: 'assure_DescriptionVie',
      //component: DescriptionAssuranceVie,
      component: () => import('./../views/DescriptionAssuranceVie.vue'),
      redirect: '/404',
      // meta: {requiresAuth: true}
      children: [
        {
          path: 'vie',
          name: 'assure_vie',
          //component: DescriptionAssuranceVieComponent,
          component: () =>
            import('./../components/assurance_page_component/DescriptionAssuranceVieComponent.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'Assurplus',
          name: 'assure_plus',
          //component: DescriptionAssuranceAssurPlusComponent,
          component: () =>
            import(
              './../components/assurance_page_component/DescriptionAssuranceAssurPlusComponent.vue'
            ),
          meta: { requiresAuth: true }
        },
        {
          path: 'sinistre',
          name: 'descriptionSinitre',
          //component: DescriptionAssuranceSinistre,
          component: () =>
            import('./../components/assurance_page_component/DescriptionAssuranceSinistre.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'Sante',
          name: 'assure_sante',
          //component: DescriptionAssuranceSante,
          component: () =>
            import('./../components/assurance_page_component/DescriptionAssuranceSante.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'Sante/entreprise',
          name: 'assure_sante',
          //component: DescriptionAssuranceSante,
          component: () =>
            import(
              './../components/assurance_page_component/DescriptionAssuranceSanteEntreprise.vue'
            ),
          meta: { requiresAuth: true }
        },
        {
          path: 'Habitation',
          name: 'assure_habitation',
          //component: DescriptionAssuranceHabitation,
          component: () =>
            import('./../components/assurance_page_component/DescriptionAssuranceHabitation.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'Auto-Moto',
          name: 'assure_auto_moto',
          //component: DescriptionAssuranceAuto,
          component: () =>
            import('./../components/assurance_page_component/DescriptionAssuranceAuto.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'Voyage',
          name: 'assure_voyage',
          //component: DescriptionAssuranceVoyage,
          component: () =>
            import('./../components/assurance_page_component/DescriptionAssuranceVoyage.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'kermel',
          name: 'DescriptionKermel',
          component: () => import('./../components/kermel/DescriptionKermel.vue'),
          //component: DescriptionKermel,
          meta: { requiresAuth: true }
        }
      ]
    },

    /*================= DEVIS =======================*/
    {
      path: '/flotte/entreprise',
      name: 'flotte_entreprise',
      component: () => import('./../components/entreprise/flotte.vue')
      //component: magiclinkLogin,
    },
    {
      path: '/faq/flotte/entreprise',
      name: 'flotte_entreprise',
      component: () => import('./../components/entreprise/faq_flotte.vue')
      //component: magiclinkLogin,
    },
    {
      path: '/flotte/auto',
      name: 'flotte_auto',
      component: () => import('./../components/DevisAuto/flotte.index.auto.vue')
      //component: magiclinkLogin,
    },
    {
      path: '/devis/auto',
      name: 'devis_auto',
      //component: IndexAuto,
      component: () => import('./../components/DevisAuto/index.auto.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devis/habitation',
      name: 'devis_habitation',
      //component: NewHabitation,
      component: () => import('./../components/devishabitation.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devis/voyage',
      component: () => import('./../views/DevisVoyageView.vue'),
      meta: { requiresAuth: true }
    },

    {
      path: '/individuel',
      name: 'individuel',
      //component: Individuel,
      component: () => import('./../components/individuel.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devis/voyage/sonam',
      name: 'devis_voyage_sonam',
      //component: VoyageSonam,
      component: () => import('./../components/VoyageSonam.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devis/sante',
      name: 'devis_sante',
      //component: NewSante,
      component: () => import('./../components/NewSante.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payement/nest',
      name: 'PayementNest',
      //component: PayementNest,
      component: () => import('./../components/Payement-nest.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payement/nest/differe',
      name: 'PayementNestDiffere',
      //component: PayementNestDiffere,
      component: () => import('./../components/PayementNestDiffere.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/paiement/differe/',
      name: 'PaiementDiffere',
      //component: PaiementDiffere,
      component: () => import('./../components/PaiementDiffere.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devis/vie',
      name: 'devis_vie',
      //component: NewVie,
      component: () => import('./../components/NewVie.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/flotte/devis/liste',
      name: 'flotteListDevis',
      //component: ListDevis,
      component: () => import('./../components/FlotteListDevis.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/devis/liste',
      name: 'listDevis',
      //component: ListDevis,
      component: () => import('./../components/ListDevis.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/simulate/devis/liste',
      name: 'listDevisSimulation',
      //component: ListDevisSimulate,
      component: () => import('./../components/Simulate/ListOffreSimulate.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/detailsvoyage/:devisid',
      name: 'Detailsvoyage',
      //component: Detailsvoyage,
      component: () => import('./../components/Detailsvoyage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/contrat/cumule',
      name: 'CumuleContrat',
      //component: AlertCumuleContrat,
      component: () => import('./../components/AlertCumuleContrat.vue'),
      meta: { requiresAuth: true }
    },
    /*================ Payement ===============*/
    {
      path: '/payement/',
      name: 'payement',
      //component: Payement,
      component: () => import('./../components/Payement.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payement/auto',
      name: 'payement_auto',
      //component: Paiement_auto,
      component: () => import('./../components/payment_auto/payment.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payement/succes/*',
      name: 'payement_succes',
      //component: PayementSucces,
      component: () => import('./../components/Payement_succes.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/paymenttouch/*',
      name: 'payementtouch_succes',
      //component: PaymentTouchSucces,
      component: () => import('./../components/Payementtouch_succes.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payement/failed',
      name: 'payement_failed',
      //component: PayementFailed,
      component: () => import('./../components/Payement_failed.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/orangemoneyrep',
      name: 'orangemoneyrep',
      //component: orangemoneyrep,
      component: () => import('./../components/orangemoneyrep.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/freemoneyrep/',
      name: 'freemoneyrep',
      //component: freemoneyrep,
      component: () => import('./../components/freemoneyrep.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/orabankrep',
      name: 'orabankrep',
      //component: orabankrep
      component: () => import('./../components/orabankrep.vue')
    },
    {
      path: '/sunu/payement',
      name: 'sunu_payement',
      //component: SunuPayement,
      component: () => import('./../components/SunuPayement.vue'),
      meta: { requiresAuth: true }
    },
    //==========================Password recovery==========
    {
      path: '/password/recovery/:token',
      name: 'password_recovery',
      //component: Passwordrecovery,
      //component: () => import('./../components/Passwordrecovery.vue'),
      component: () => import('./../components/auth/ResetPassword.vue'),
      meta: { requiresAuth: true }
    },
    //==========================Info Legales ================
    {
      path: '/info/legale',
      name: 'info_legale',
      //component: InfoLegale,
      component: () => import('./../components/InfoLegale.vue'),
      meta: { requiresAuth: true }
    },
    //==========================Info Legales ================
    {
      path: '/condition/generale',
      name: 'condition_generale',
      //component: condition_generale,
      component: () => import('./../components/ConditionGenerale.vue'),
      meta: { requiresAuth: true }
    },
    //==========================Page kermel ================
    {
      path: '/sante/kermel/',
      name: 'kermel',
      //component: Kermel,
      component: () => import('./../components/Kermel.vue'),
      meta: { requiresAuth: true }
    },
    //==========================Page kermel famille ================
    {
      path: '/sante/kermel/famille',
      name: 'Famille',
      //component: Famille,
      component: () => import('./../components/kermel/Famille.vue'),
      meta: { requiresAuth: true }
    },
    //==========================Page kermel Suivi pathologie ================
    {
      path: '/sante/kermel/suivi',
      name: 'SuiviPathologie',
      //component: SuiviPathologie,
      component: () => import('./../components/kermel/SuiviPathologie.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/sinsitre/history',
      name: 'historique_sinistre',
      component: SinistreHistory,
      meta: { requiresAuth: true }
    },
    {
      path: '/payemntbylink/*',
      name: 'payemnt_by_link',
      //component: newPaymentLink,
      component: () => import('./../components/new_payment_link.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/invalidelink',
      name: 'invalide_payemnt_link',
      component: () => import('./../components/invalideLink.vue'),
      //component: invalideLink,
      meta: { requiresAuth: true }
    },
    {
      path: '/devis/sunuassur',
      name: 'Devis_sunuAssur',
      //component: NewSunuAssur,
      component: () => import('./../components/newSunuAssur.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/nsiaetudes',
      name: 'Devis_nsia',
      //component: NewNsiaEtude,
      component: () => import('./../components/newNsiaEtude.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment_sunu',
      name: 'payment_sunu',
      //component: Payment_Sunu,
      component: () => import('./../components/payment_Sunu.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/link/Baduser',
      name: 'Baduser_payment_link',
      //component: BadUserForPaymentLink,
      component: () => import('./../components/BadUserForPaymentLink.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/ContactForm/',
      name: 'ContactForm',
      component: () => import('./../components/ContactForm.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/contactform/:subject',
      name: 'contactform',
      component: () => import('./../components/Contact.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/reccurent/pay',
      name: 'reccurentPay',
      component: () => import('./../components/RecurrentPay.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/plus',
      name: 'assurPlus',
      component: () => import('./../components/assur_plus/assurPlus.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/sonac',
      name: 'sonac',
      component: () => import('./../components/assur_plus/sonac/Sonac.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/sonac/caution',
      name: 'caution',
      component: () => import('./../components/assur_plus/sonac/caution.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/sonac/assurance',
      name: 'assurance',
      component: () => import('./../components/assur_plus/sonac/assurCredit.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/cnaas',
      name: 'cnaas',
      component: () => import('./../components/assur_plus/cnaas/cnaas.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/cnaas/agricole',
      name: 'agricole',
      component: () => import('./../components/assur_plus/cnaas/agricole.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/cnaas/betail',
      name: 'betail',
      component: () => import('./../components/assur_plus/cnaas/betail.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/cnaas/volaille',
      name: 'volaille',
      component: () => import('./../components/assur_plus/cnaas/volaille.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/sante/assurcare',
      name: 'assur_care',
      component: () => import('./../components/new_assur_care.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/assur/euleuk',
      name: 'assurEuleuk',
      component: () => import('./../components/newAssurEuleuk'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/micro/sunuvie',
      name: 'assurHospi',
      component: () => import('./../components/micro_vie/Assur_hospi.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/wave/*',
      name: 'wavepayment',
      component: () => import('./../components/wave_response.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/cloud/wave/*',
      name: 'wavecloudpayment',
      component: () => import('./../components/cloudwave.vue'),
      meta: { requiresAuth: false }
    },
    //========================== Page entreprise ================
    {
      path: '/devis/mrp',
      name: 'Devis_mrp',
      component: () => import('./../components/entreprise/mRP.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/devis/trc',
      name: 'Devis_trc',
      component: () => import('./../components/entreprise/tRC.vue'),
      meta: { requiresAuth: false }
    },
    //========================== Page simulation Devis Auto ================
    {
      path: '/simulate/devis/auto',
      name: 'SimulationDevisAuto',
      component: () => import('./../components/Simulate/index.auto.vue'),
      meta: { requiresAuth: false }
    },
    //========================== Page simulation Devis Voyage ================
    {
      path: '/simulate/devis/voyage',
      name: 'SimulationDevisVoyage',
      component: () => import('./../components/Simulate/index.voyage.vue'),
      meta: { requiresAuth: false }
    },
    //========================== Schedule demo route ================
    {
      path: '/plateforme/demo',
      name: 'schedule_demo',
      component: () => import('./../components/schedule_demo/ScheduleDemo.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/plateforme',
      name: 'plateforme',
      component: () => import('./../components/schedule_demo/plateform.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/lead',
      name: 'LeadPage',
      component: () => import('./../components/Leads/LeadPage.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/cv',
      name: 'cv_fiscal',
      component: () => import('../components/calculate/CvFiscal.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/aywa/:agentCode?',
      name: 'aywa_subscription',
      component: () => import('./../components/aywa/AywaPage.vue'),
      props: true,
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/aywa/wave/*',
      name: 'aywapayment',
      component: () => import('./../components/aywa/checkContrat.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/aywa/failed',
      name: 'aywapaymentFailed',
      component: () => import('./../components/aywa/paymentFailed.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/tukki/:agentCode?',
      name: 'tukki_subscription',
      component: () => import('./../components/devis/Tukki/TukkiPage.vue'),
      props: true,
      meta: { requiresAuth: false }
    },
     {
      path: '/payment/tukki/wave/*',
      name: 'tukkipayment',
      component: () => import('./../components/devis/Tukki/checkContrat.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/tukki/failed',
      name: 'tukkipaymentFailed',
      component: () => import('./../components/devis/Tukki/paymentFailed.vue'),
      meta: { requiresAuth: false }
    },
    // Go routes
    {
      path: '/dem/:agentCode?',
      name: 'dem_subscription',
      component: () => import('../components/devis/Dem/GoPage.vue'),
      props: true,
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/dem/wave/*',
      name: 'dempayment',
      component: () => import('../components/devis/Dem/checkContrat.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/payment/dem/failed',
      name: 'dempaymentFailed',
      component: () => import('../components/devis/Dem/paymentFailed.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/unavailable',
      name: 'page_neutre',
      component: () => import('./../views/PageNeutre.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/404',
      name: 'notFound',
      component: () => import('./../components/NotFound.vue')
    },
    { path: '*', redirect: '/404' }
  ]
});